import React, { useState } from 'react';
import { get } from 'lodash';
import { toast } from 'react-toastify';
import { TextField } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import { StyledDiv } from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/Dialog/styles';
import DecisionDialog from 'components/DecisionDialog/index';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/messages';
import {
  MISSION_POSTPONE_STATUS,
  MISSION_POSTPONE_TYPE,
} from 'containers/data-structure';
import currentUserStorage from 'containers/services/security/current-user-storage';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
export interface ValidationDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  validateDialog: Function;
  recap: any;
  claimId: number;
  claimNumber: string;
  setOpenFeeNoteDialog: Function;
}

const ValidationDialog: React.FC<ValidationDialogProps> = (
  props,
): JSX.Element => {
  const { onClose, open } = props;
  const [comment, setComment] = useState('');
  const handleChangeComment = (event: any) => {
    setComment(event.target.value);
  };
  const successCallBack = () => {
    toast.success(
      translate(messages.validationDecisonToastPostPone, props, {
        type: get(props.recap, 'missionPostPone.type'),
      }),
    );
    props.onClose();
    if (
      get(props.recap, 'missionPostPone.type') ===
        MISSION_POSTPONE_TYPE.NOTICE_DEFICIENCY &&
      featureService.hasFeature(FEATURES.EVOLUTIONS_FEE_NOTE)
    ) {
      /* istanbul ignore next */
      props.setOpenFeeNoteDialog(true);
    }
  };
  const handleValidate = () => {
    props.validateDialog(
      {
        status: MISSION_POSTPONE_STATUS.VALIDATED,
        id: get(props.recap, 'missionPostPone.id'),
        decidedBy: currentUserStorage.get().username,
        type: get(props.recap, 'missionPostPone.type'),
        comment: comment,
        claimId: props.claimId,
        postponeDate: get(props.recap, 'missionPostPone.postponeDate', null),
        missionId: get(props.recap, 'missionPostPone.missionId'),
        expertCode: get(props.recap, 'missionPostPone.createdBy'),
        claimNumber: props.claimNumber,
        isInboxesActive: featureService.hasFeature(
          FEATURES.ATTRIBUTION_INBOXES_MANAGER,
        ),
        isTrackingActive: featureService.hasFeature(
          FEATURES.TRACKING_ACTIONS_USER,
        ),
      },
      successCallBack,
    );
  };
  return (
    <DecisionDialog
      open={open}
      onClose={onClose}
      validateDialog={handleValidate}
      title={translate({ ...messages.decisionTitle }, props)}
      content={
        <StyledDiv>
          <TextField
            onChange={handleChangeComment}
            name={'comment'}
            value={comment}
            label={translate({ ...messages.comment }, props)}
            className="input"
            multiline
            fullWidth
          />
        </StyledDiv>
      }
      disabled={false}
      primaryButtonTitle={translate(messages.dialogValidationButton, props)}
      scondaryButtonTitle={translate(messages.dialogCancelButton, props)}
    />
  );
};

ValidationDialog.defaultProps = {
  open: false,
};

export default injectIntl(ValidationDialog);
